import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

export default function RenderDeadReports({ row }: ICasRenderCellProps) {
  const { unspecified, deadsReported } = row;

  if (!deadsReported && !unspecified) return null;

  return (
    <>
      {deadsReported || ''}
      {unspecified ? '+' : ''}
    </>
  );
}
